export default "__VITE_ASSET__Bd$RvZR4__"